/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import DayPicker, { DateUtils, Modifier, RangeModifier } from 'react-day-picker';
import {
  useMonthPeriod,
  useShortDateFormat,
  useOutsideAlerter,
  useToggleBoolean,
} from '@common/hooks/logbook';
import { ReactComponent as Calendar } from '@assets/svg/icons/logbook/CalendarOutlined.svg';
import { ReactComponent as Left } from '@assets/svg/icons/logbook/ChevronLeft.svg';
import { ReactComponent as Right } from '@assets/svg/icons/logbook/ChevronRight.svg';
import { DriveTabs } from '@common/constants/logbook';
import { useLogbookContext } from '@context';
import 'react-day-picker/lib/style.css';
import './index.scss';

const Navbar = ({ onPreviousClick, onNextClick, className, month }: any) => {
  const { selectedTab } = useLogbookContext();
  const isCurrentMonth = month.getMonth() === new Date().getMonth();

  const color = (cond: boolean) => (cond && isCurrentMonth ? '#96A1A8' : 'white');

  const isToDo = selectedTab === DriveTabs.toDo;
  const isDone = selectedTab === DriveTabs.done;

  return (
    <div className={className}>
      <Left className="arrow-left" fill={color(isToDo)} onClick={() => onPreviousClick()} />
      <Right className="arrow-right" fill={color(isDone)} onClick={() => onNextClick()} />
    </div>
  );
};

const Picker = React.forwardRef<HTMLAnchorElement & HTMLDivElement, PickerProps>(
  ({ onApply, range, onDayClick, onClear, month, onMonthChange }: PickerProps, ref) => {
    const { selectedTab, setDatePeriod } = useLogbookContext();

    const [initialFirsDate, initialLastDate] = useMonthPeriod(
      new Date().getFullYear(),
      new Date().getMonth(),
    );

    const { from, to } = range;
    const modifiers = { start: from as Modifier, end: to as Modifier };

    const handleApply = () => {
      setDatePeriod({
        first: range.from ? range.from : initialFirsDate,
        last: range.to ? range.to : range.from ? range.from : initialLastDate,
      });
      onApply();
    };

    return (
      <div ref={ref} className="picker-container">
        <DayPicker
          className="Selectable"
          initialMonth={month}
          navbarElement={(props: any) => <Navbar {...props} month={month} />}
          toMonth={selectedTab === DriveTabs.done ? new Date() : undefined}
          fromMonth={selectedTab === DriveTabs.toDo ? new Date() : undefined}
          onMonthChange={onMonthChange}
          onDayClick={onDayClick}
          selectedDays={[from as Modifier, { from, to }]}
          modifiers={modifiers}
        />
        <div className="picker-line" />
        <div className="picker-buttons-container row">
          <button className="picker-text-button mlb-button" type="button" onClick={onClear}>
            clear
          </button>
          <button className="picker-button mlb-button" type="button" onClick={handleApply}>
            apply
          </button>
        </div>
      </div>
    );
  },
);

const DatePicker = () => {
  const { datePeriod } = useLogbookContext();

  const firstDay = useShortDateFormat(datePeriod.first);
  const lastDay = useShortDateFormat(datePeriod.last);

  const [isShown, toggleIsShown] = useToggleBoolean();

  const wrapperRef = React.createRef<HTMLAnchorElement & HTMLDivElement>();

  useOutsideAlerter(wrapperRef, toggleIsShown);

  // @ts-ignore
  const [range, setRange] = useState<RangeModifier>({ from: undefined, to: undefined });
  const handleDayClick = (day: Date) => {
    setRange(DateUtils.addDayToRange(day, range));
  };

  const handleClear = () => {
    // @ts-ignore
    setRange({ from: undefined, to: undefined });
  };

  const [month, setMonth] = useState(new Date());

  return (
    <>
      <div className="row-centered time-period-container" onClick={toggleIsShown}>
        <p className="time-period-title">time period:</p>
        <p className="time-period-dates">
          {firstDay} {firstDay !== lastDay ? `- ${lastDay}` : ''}
        </p>
        <Calendar />
      </div>
      {isShown && (
        <Picker
          month={month}
          onMonthChange={setMonth}
          onClear={handleClear}
          onDayClick={handleDayClick}
          range={range}
          ref={wrapperRef}
          onApply={toggleIsShown}
        />
      )}
    </>
  );
};

type PickerProps = {
  month: Date;
  onApply: () => void;
  onClear: () => void;
  range: RangeModifier;
  onMonthChange: (d: Date) => void;
  onDayClick: (d: Date) => void;
};

export default DatePicker;
